export default function HeroSection() {
  const handleScrollTo = (e: React.MouseEvent<HTMLAnchorElement>, target: string) => {
    e.preventDefault();
    const el = document.querySelector(target);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden">
        <img
          src="https://readdy.ai/api/search-image?query=Dynamic%20warm%20toned%20abstract%20digital%20background%20with%20flowing%20gradients%20of%20crimson%20and%20amber%2C%20subtle%20geometric%20patterns%2C%20news%20information%20flow%20visualization%2C%20clean%20and%20modern%20style%2C%20soft%20atmospheric%20light%2C%20no%20text%20or%20lettering%2C%20professional%20editorial%20design%20feel&width=1600&height=900&seq=hero-bg-51bl&orientation=landscape"
          alt=""
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-background-950/75 via-background-950/50 to-primary-950/60"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-16 md:py-20">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-5">
              <i className="ri-flashlight-line text-sm text-primary-400"></i>
              <span className="text-xs font-medium text-primary-300 whitespace-nowrap">每日更新 · 实时追踪</span>
            </div>

            <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black font-heading text-background-50 leading-tight tracking-tight">
              51爆料
              <span className="block text-primary-400 mt-1">每日爆料聚合与话题竞赛平台</span>
            </h1>

            <p className="mt-2 text-base md:text-lg text-accent-300/90 font-medium font-heading">
              爆点不断 · 热度不散 · 每天都有新发现
            </p>

            <p className="mt-6 text-sm md:text-base text-background-200/80 leading-relaxed max-w-xl mx-auto lg:mx-0">
              51爆料每日大赛专区致力于聚合全网最新最热的爆料内容。我们每日更新51每日爆料、大赛排行与话题竞赛，
              覆盖娱乐、社会、科技、体育等多个领域，助你第一时间掌握热点动态。
              无论你是吃瓜群众还是深度追踪者，这里都有你想要的每日爆料汇总，紧跟每日热点，不错过任何一个爆点。
            </p>

            <div className="mt-6 flex flex-wrap items-center justify-center lg:justify-start gap-6 text-sm">
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-background-200 whitespace-nowrap">每日更新 300+ 条目</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-primary-400"></span>
                <span className="text-background-200 whitespace-nowrap">覆盖 12 大领域</span>
              </div>
              <div className="flex items-center gap-2">
                <span className="w-2 h-2 rounded-full bg-accent-400"></span>
                <span className="text-background-200 whitespace-nowrap">实时追踪 7×24</span>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#index"
                onClick={(e) => handleScrollTo(e, '#index')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all cursor-pointer no-underline whitespace-nowrap"
              >
                <i className="ri-compass-3-line text-lg"></i>
                探索今日爆料
              </a>
              <a
                href="#ranking"
                onClick={(e) => handleScrollTo(e, '#ranking')}
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm border border-background-50/30 hover:bg-background-50/25 transition-all cursor-pointer no-underline whitespace-nowrap"
              >
                <i className="ri-fire-line text-lg"></i>
                查看热度榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="relative w-full aspect-[4/3] rounded-2xl overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=A%20dramatic%20and%20dynamic%20editorial%20illustration%20of%20breaking%20news%20and%20information%20flow%2C%20warm%20crimson%20and%20amber%20color%20palette%2C%20abstract%20data%20visualization%20elements%2C%20geometric%20patterns%20representing%20network%20connections%2C%20modern%20digital%20art%20style%2C%20energy%20and%20movement%20feel%2C%20no%20text%20or%20lettering%2C%20atmospheric%20lighting%2C%20professional%20quality&width=1200&height=900&seq=hero-visual-51bl&orientation=landscape"
                alt="51爆料每日大赛主视觉 - 热点爆料信息流"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-primary-950/40 to-transparent rounded-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}